import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../security/authentication.service';
import { User } from '../entity/user';

@Component({
  selector: 'account',
  templateUrl: './account.component.html'
})
export class AccountComponent {
  currentUser: User = null;

  constructor(private authenticationService: AuthenticationService) { }

  ngOnInit(): void {
    this.currentUser = this.authenticationService.getCurrentUser();
    this.authenticationService.userChanged$.subscribe(user => this.onUserChanged(user));
  }

  private onUserChanged(user: User): void {
    this.currentUser = user;
  }

}


// WEBPACK FOOTER //
// ./src/app/account/account.component.ts